import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { Tabs, Tab, Box, Container } from '@mui/material';
import { useSelector } from 'react-redux';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import AgentRoute from './AgentRoute';
import EditCreateDetailAgent from './EditCreateDetailAgent';
import MobileInformation from '../MobileInformation/MobileInformation';
import { FielderSmartTab, FielderSmartTabs } from '~/FielderElements/Utils/SmartTabNav';

export default function AgentDetailContainer(props) {
  const {
    agent: agentProp,
    idAgent: idAgentProp,
    lan,
    showAction,
    editAgentAction,
    skillsElegible,
    showEdit,
  } = props;
  const session = useSelector((state) => state.utils.session);
  const user = session?.user;
  const [tab, setTab] = useState('info');
  const [agent, setAgent] = useState(agentProp);
  const [idAgent, setIdAgent] = useState(agentProp?.idAgent ?? idAgentProp ?? 0);
  const [displayModal, setDisplayModal] = useState(true);
  const [agentMobileInformation, setAgentMobileInformation] = useState({
    deviceName: '',
    deviceSystemVersion: '',
    fielderVersion: '',
    battery: '',
    locationPrecisePermission: '',
    locationApproximatePermission: '',
    locationBackgroundPermission: '',
  });
  useEffect(() => {
    if (agentProp?.idAgent) setIdAgent(agentProp.idAgent);
    setAgent(agentProp);
  }, [agentProp]);
  const changeDisplayModal = useCallback(() => setDisplayModal((v) => !v), []);
  const handlerAgent = useCallback((a) => setAgent(a), []);
  const passMobileInformation = useCallback(
    (info) => {
      const safe = (v, fallback) => (v === undefined || v === null ? fallback : v);
      setAgentMobileInformation({
        deviceName: safe(info?.deviceName, lan.noData),
        deviceSystemVersion: safe(info?.deviceSystemVersion, lan.noData),
        fielderVersion: safe(info?.fielderVersion, lan.noData),
        battery: safe(info?.battery, 0),
        locationPrecisePermission:
          info?.locationPrecisePermission == null
            ? lan.noData
            : info.locationPrecisePermission
              ? lan.accepted
              : lan.withoutAccepting,
        locationApproximatePermission:
          info?.locationApproximatePermission == null
            ? lan.noData
            : info.locationApproximatePermission
              ? lan.accepted
              : lan.withoutAccepting,
        locationBackgroundPermission:
          info?.locationBackgroundPermission == null
            ? lan.noData
            : info.locationBackgroundPermission
              ? lan.accepted
              : lan.withoutAccepting,
      });
    },
    [lan]
  );
  const isClient = RoleUtils.isUserClient(user);
  const tabs = useMemo(() => {
    const base = [{ key: 'info', label: lan.information }];
    if (!isClient) {
      base.push({ key: 'route', label: lan.geolocations });
      base.push({ key: 'mobileInfo', label: lan.mobileInformation });
    }
    return base;
  }, [isClient, lan]);
  useEffect(() => {
    if (!tabs.some((t) => t.key === tab)) setTab('info');
  }, [tabs, tab]);
  return (
    <>
      {/* Tabs Header */}
      <Box
        sx={{
          px: 2,
          mb: 2,
          bgcolor: 'background.paper',
          borderBottom: 1,
          borderColor: 'divider',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <FielderSmartTabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          centered
        >
          {tabs.map((t) => (
            <FielderSmartTab key={t.key} value={t.key} label={t.label} />
          ))}
        </FielderSmartTabs>
      </Box>

      {/* INFO */}
      {tab === 'info' && (
        <Container disableGutters sx={{ minHeight: 400, px: 2 }}>
          <EditCreateDetailAgent
            {...props}
            showAction={showAction}
            editAgentAction={editAgentAction}
            skillsElegible={skillsElegible}
            agent={agent}
            lan={lan}
            updateParentAgent={handlerAgent}
            idAgent={idAgent}
            showEdit={showEdit}
            passMobileInformation={passMobileInformation}
            displayModal={displayModal}
            changeDisplayModal={changeDisplayModal}
          />
        </Container>
      )}
      {/* ROUTE (only for non-client users) */}
      {tab === 'route' && !isClient && (
        <Container disableGutters sx={{ minHeight: 400, px: 2 }}>
          <AgentRoute {...props} agent={agent} />
        </Container>
      )}
      {/* MOBILE INFO (only for non-client users) */}
      {tab === 'mobileInfo' && !isClient && (
        <Container disableGutters sx={{ minHeight: 300, px: 2 }}>
          <MobileInformation userMobileInformation={agentMobileInformation} isAgent />
        </Container>
      )}
    </>
  );
}
